import { faFlaskVial } from '@fortawesome/pro-regular-svg-icons';
import OrderALaCarteButton from '../OrderALaCarteButton';
import {
  EMPTY_STATE_BODY,
  EMPTY_STATE_CTA_LABEL,
  EMPTY_STATE_FOOTER,
  EMPTY_STATE_HINT,
  EMPTY_STATE_TITLE,
} from './constants';
import { EmptyActions, EmptyBody, EmptyFooter, EmptyHint, EmptyIcon, EmptyRoot, EmptyTitle } from './styled';

const EmptyState = () => {
  return (
    <EmptyRoot>
      <EmptyIcon icon={faFlaskVial} aria-hidden />
      <EmptyTitle>{EMPTY_STATE_TITLE}</EmptyTitle>
      <EmptyBody>{EMPTY_STATE_BODY}</EmptyBody>
      <EmptyHint>{EMPTY_STATE_HINT}</EmptyHint>
      <EmptyActions>
        <OrderALaCarteButton label={EMPTY_STATE_CTA_LABEL} />
      </EmptyActions>
      <EmptyFooter>{EMPTY_STATE_FOOTER}</EmptyFooter>
    </EmptyRoot>
  );
};

export default EmptyState;
